<template>
  <div class="mark page-list">
    <v-card>
      <v-card-title> <h1>Marcas</h1> </v-card-title>
      <v-data-table
        :mobile-breakpoint="768"
        :headers="tableHeaders"
        :items="listData"
        :search="search"
        :loading="loaderTable"
        :footer-props="{
          itemsPerPageOptions: [10, 25, 50, 100, -1],
        }"
        loading-text="Cargando... Por favor espere."
      >
        <template v-slot:[`item.photo`]="{ item }">
          <img class="imgMark" :src="item.photo | urlImage" alt="mark" />
        </template>

        <template v-slot:[`item.actions`]="{ item, index }">
          <CustomButtonAction
            :value="item"
            :btnEdit="true"
            :btnDelete="true"
            :index="index"
            :loaderDelete="loaderDelete"
            @onChangeEdit="editItem($event)"
            @onChangeDelete="deleteItem($event, index)"
          />
        </template>

        <template v-slot:top>
          <v-toolbar flat>
            <v-row>
              <v-col cols="11" md="6">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Buscar ..."
                  single-line
                  hide-details
                  outlined
                  dense
                  clearable
                  color="second"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-spacer></v-spacer>

            <EditMark
              :dialog.sync="editModal"
              :edit.sync="editView"
              :data="selectItem"
              @onChange="firstRowData($event)"
            />

            <CustomDialog
              :dialog.sync="deleteModal"
              :title="'Confirmar eliminación'"
              :message="'¿Estás seguro que quieres eliminar el registro?'"
              :maxWidth="'320'"
              @onChange="btnDelete()"
            ></CustomDialog>
          </v-toolbar>
          <v-divider></v-divider>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import useColumns from "./useColumns";
import EditMark from "./edit-mark.vue";
import MarkServices from "../../../../core/services/mark-services";
import MarkStorage from "../../../../core/storage/mark-storage";
import CustomButtonAction from "../../../../shared/components/custom-button-action/CustomButtonAction.vue";
import CustomDialog from "../../../../shared/components/custom-dialog/CustomDialog.vue";

export default {
  name: "Mark",
  data: () => ({
    search: "",
    editView: false,
    editModal: false,
    deleteModal: false,
    selectItem: {},
    listData: [],
    loaderTable: false,
    loaderDelete: {},
    selectIndex: null,
    tableHeaders: useColumns,
  }),
  components: {
    EditMark,
    CustomButtonAction,
    CustomDialog,
  },
  created() {
    this.getMark();
    this.getAllMark();
  },
  methods: {
    editItem(item) {
      this.editModal = true;
      this.editView = true;
      this.selectItem = item;
    },
    deleteItem(item, index) {
      this.deleteModal = true;
      this.selectItem = item;
      this.selectIndex = index;
    },
    async getMark() {
      const { markAll } = MarkStorage();
      this.listData = await markAll();
    },
    getAllMark() {
      this.loaderTable = true;
      const { getMarkAll } = MarkServices();
      const { markAdd } = MarkStorage();
      getMarkAll().then((resp) => {
        const response = resp.data;
        if (response.code == 200) {
          response.data.map((item) => {
            markAdd(item);
          });
          this.getMark();
        }
        this.loaderTable = false;
      });
    },
    firstRowData(data) {
      const { markAdd } = MarkStorage();
      markAdd(data);
      this.getMark();
    },
    btnDelete() {
      const { deleteMarkId } = MarkServices();
      const { markDeleteById } = MarkStorage();
      const index = this.selectIndex;
      this.loaderDelete = { [index]: true };

      deleteMarkId(this.selectItem.id).then((resp) => {
        const response = resp.data;
        if (response.code == 200) {
          markDeleteById(this.selectItem.id);
          this.getMark();
          this.$toast.success("El registro ha sido eliminado exitosamente");
        }
        this.loaderDelete = { [index]: false };
      });
    },
  },
};
</script>

<style lang="scss">
.mark {
  .imgMark {
    width: 150px;
    padding: 10px;
  }
}
</style>
